





































































































import {
  Component, Vue, Prop, PropSync, Watch,
} from 'vue-property-decorator';

import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';

import numberFormat from '@/libs/numberFormat';

@Component({
  components: {
    LayoutContent,
    FormInput,
  },
  methods: {
    numberFormat,
  },
})

export default class InternalDetailTraffic extends Vue {
  /* eslint-disable */
  numberFormat!: typeof numberFormat;

  // trafficPerDay: any[] = [];

  cancelChange() {
    try {
      this.trafficPerDay.forEach((data: any) => {
        data.merchant_traffic = data.merchant_traffic_temp;
        data.merchant_amount = data.merchant_amount_temp;
      })
    } catch (error) {
      console.log(error);
    }
  }

  hitungDetail(type: string, itemData: any) {
    try {
      const price: any = this.selectedPeriod.price_per_transaction;
      const listPrice: any[] = price.split(",");
      switch (type) {
        case "mdr_fee": {
          return parseFloat(itemData.merchant_amount || 0) * parseFloat(listPrice[1] || 0);
        }
        case "normal_fee": {
          return parseInt(itemData.merchant_traffic || 0) * parseFloat(listPrice[0] || 0);
        }
        case "billing_total": {
          return (parseFloat(itemData.merchant_amount || 0) * parseFloat(listPrice[1] || 0)) +
            (parseInt(itemData.merchant_traffic || 0) * parseFloat(listPrice[0] || 0));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  hitungTotal(type: string) {
    try {
      let total = 0;
      switch (type) {
        case "sprint": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += parseInt(data.sprint_traffic || 0);
            })
          }
          break;
        }
        case "merchant": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += parseInt(data.merchant_traffic || 0);
            })
          }
          break;
        }
        case "difference": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += (parseInt(data.sprint_traffic || 0) - parseInt(data.merchant_traffic || 0));
            })
          }
          break;
        }
        case "merchant_amount": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += parseInt(data.merchant_amount || 0);
            })
          }
          break;
        }
        case "mdr_fee":
        case "normal_fee":
        case "billing_total": {
          if (this.trafficPerDay) {
            this.trafficPerDay.forEach((data: any) => {
              total += this.hitungDetail(type, data) || 0;
            })
          }
          break;
        }
      }
      return numberFormat(total);
    } catch (error) {
      console.log(error);
    }
  }

  getBillType() {
    try {
      let multiple_billType = JSON.parse(this.selectedPeriod.multiple_billType || "[]");
      if (multiple_billType.length > 1) {
        return 'mixed';
      } else if (multiple_billType.length > 0) {
        return multiple_billType[0].type;
      } else {
        this.selectedPeriod.billType;
      };
    } catch (error) {
      console.log(error);
      return '';
    }
  }

  isDifferent(itemData: any) {
    try {
      if (/normal|tiring/.test(this.getBillType())) {
        return (parseInt(itemData.sprint_traffic || 0) - parseInt(itemData.merchant_traffic || 0)) !== 0
      } else {
        return (parseInt(itemData.sprint_traffic || 0) - parseInt(itemData.merchant_traffic || 0)) !== 0 ||
          (parseInt(itemData.amount || 0) - parseInt(itemData.merchant_amount || 0)) !== 0
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  @PropSync('trafficPerDayProp') trafficPerDay!: any[];
  @Prop() readonly internalDisagree!: boolean;
  @Prop() readonly selectedPeriod!: any;

  @Watch('selectedPeriod')


  @Watch('trafficPerDay')
  trafficPerDayChanged() {
    this.$emit('trafficPerDayChanged', this.trafficPerDay);
  }

  @Watch('internalDisagree')
  internalDisagreeChanged() {
    if (this.internalDisagree) {
      console.log('klik disagree');
      this.trafficPerDay.forEach((data: any) => {
        data.merchant_traffic_temp = data.merchant_traffic;
        data.merchant_traffic = data.sprint_traffic;
        data.merchant_amount_temp = data.merchant_amount;
        data.merchant_amount = data.amount;
      })
    }
  }

}
